import { CSS } from '@grupoboticario/flora-react'

export const summaryCss: CSS = {
  flexShrink: 0,
  width: '100%'
}

export const detailsRowCss: CSS = {
  width: '100%'
}

export const cardCss: CSS = {
  backgroundColor: '$backgroundSecondary',
  flex: 1,
  minHeight: '114px',
  padding: '$4',
  borderRadius: '$medium'
}

export const errorTextCss: CSS = {
  color: '$error-standard'
}

export const getDynamicColorCss = (color: string): CSS => ({
  color
})
